import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';

export type PersistedInvoiceSelection = {
  id: string;
  identifier: string;
  priceWithTaxes: string;
};

export type PersistedInvoiceSelectionsState = {
  selectionsByCompany: Record<string, PersistedInvoiceSelection[]>;
};

const STORE_KEY = 'persistedInvoiceSelections';

export const persistedInvoiceSelectionsPersistConfig = {
  key: STORE_KEY,
  whitelist: ['selectionsByCompany'],
  storage,
};

const initialState: PersistedInvoiceSelectionsState = {
  selectionsByCompany: {},
};

const persistedInvoiceSelectionsSlice = createSlice({
  name: STORE_KEY,
  initialState,
  reducers: {
    addInvoice: (
      state,
      action: PayloadAction<{ clientCompanyId: string; invoice: PersistedInvoiceSelection }>,
    ) => {
      const { clientCompanyId, invoice } = action.payload;
      if (!state.selectionsByCompany[clientCompanyId]) {
        state.selectionsByCompany[clientCompanyId] = [];
      }
      const exists = state.selectionsByCompany[clientCompanyId].some((i) => i.id === invoice.id);
      if (!exists) {
        state.selectionsByCompany[clientCompanyId].push(invoice);
      }
    },
    removeInvoice: (
      state,
      action: PayloadAction<{ clientCompanyId: string; invoiceId: string }>,
    ) => {
      const { clientCompanyId, invoiceId } = action.payload;
      if (state.selectionsByCompany[clientCompanyId]) {
        state.selectionsByCompany[clientCompanyId] = state.selectionsByCompany[
          clientCompanyId
        ].filter((i) => i.id !== invoiceId);
        if (state.selectionsByCompany[clientCompanyId].length === 0) {
          delete state.selectionsByCompany[clientCompanyId];
        }
      }
    },
    clearSelections: (state, action: PayloadAction<{ clientCompanyId: string }>) => {
      delete state.selectionsByCompany[action.payload.clientCompanyId];
    },
  },
});

export const { addInvoice, removeInvoice, clearSelections } =
  persistedInvoiceSelectionsSlice.actions;
export const persistedInvoiceSelectionsReducer = persistedInvoiceSelectionsSlice.reducer;
